export default __webpack_public_path__ + "static/media/skye-logo-white.c77301ee.svg";